import moment from "moment";
import React from "react";
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Navbar,
  OverlayTrigger,
  Popover,
  Image,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import FinancialTotals from "../FinancialTotals";
import MaterialTotals from "../MaterialTotals";
import DateNavigator from "./DateNavigator";
import Filters from "./Filters";
import Logo from "../../../assets/Logo.svg";

const SchedulerNavbar = ({
  bidTypes,
  date,
  detailEnabled,
  jobStatuses,
  appointmentTypes,
  jobTypes,
  loading,
  locationEnabled,
  mode,
  offices,
  onNavigate,
  onOpenSettingsModal,
  onSettingsChange,
  onToggleDetail,
  onToggleLocation,
  salespeople,
  settings,
  showFinancials,
  schedulerView,
  onSchedularViewButtonClick,
  selectJobsTab,
  onAppointmentCalenderClick,
}) => {
  const onButtonClick = () => {
    if (schedulerView === "equipment") {
      onSchedularViewButtonClick("crew");
    } else {
      onSchedularViewButtonClick("equipment");
      selectJobsTab();
    }
  };
  return (
    <Navbar fixedTop fluid>
      <Navbar.Header>
        <Navbar.Brand>
          <a href="/">
            <Image
              src={Logo}
              responsive
              style={{ height: "30px", minHeight: "30px" }}
            />
          </a>
        </Navbar.Brand>
      </Navbar.Header>
      <Navbar.Text>
        <DateNavigator date={date} mode={mode} onNavigate={onNavigate} />
        <Button
          onClick={() => onAppointmentCalenderClick(true)}
          style={{ marginLeft: "10px" }}
        >
          {"Add Appointment"}
        </Button>
      </Navbar.Text>

      <Navbar.Form pullRight>
        <ButtonToolbar>
          <ButtonGroup>
            <Button
              active={detailEnabled}
              bsStyle="default"
              onClick={() => onButtonClick()}
            >
              {schedulerView === "crew"
                ? "Show Equipment View"
                : "Show Crew View"}{" "}
            </Button>
            <Button
              active={detailEnabled}
              bsStyle="default"
              onClick={onToggleDetail}
            >
              Detail
            </Button>
            <Button
              active={locationEnabled}
              bsStyle="default"
              onClick={onToggleLocation}
            >
              Location
            </Button>
            {showFinancials && <FinancialTotals />}
            <MaterialTotals />
          </ButtonGroup>
          <Button bsStyle="default" onClick={() => onOpenSettingsModal()}>
            <FontAwesome name="cog" />
          </Button>
          <OverlayTrigger
            placement="bottom"
            rootClose
            trigger="click"
            overlay={
              <Popover id="filterPopover" title="Filter Calendar">
                <Filters
                  bidTypes={bidTypes}
                  filters={settings}
                  jobStatuses={jobStatuses}
                  jobTypes={jobTypes}
                  offices={offices}
                  onFilterUpdate={onSettingsChange}
                  salespeople={salespeople}
                  settings={settings}
                />
              </Popover>
            }
          >
            <Button>
              <FontAwesome name="filter" />
            </Button>
          </OverlayTrigger>
          <Button disabled={loading} onClick={() => onNavigate(date, mode)}>
            <FontAwesome name="refresh" spin={loading} />
          </Button>
          <ButtonGroup style={{ marginLeft: "10px" }}>
            <Button
              active={mode === "month"}
              bsStyle="warning"
              onClick={() => onNavigate(date, "month")}
            >
              Month
            </Button>
            <Button
              active={mode === "week"}
              bsStyle="warning"
              onClick={() => onNavigate(date, "week")}
            >
              Week
            </Button>
            <Button
              active={mode === "day"}
              bsStyle="warning"
              onClick={() => {
                onNavigate(moment(date).format("YYYY-MM-DD"), "day");
              }}
            >
              Day
            </Button>
            <Button
              active={mode === "dispatch"}
              bsStyle="warning"
              onClick={() => onNavigate(date, "dispatch")}
            >
              Dispatch
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </Navbar.Form>
    </Navbar>
  );
};

export default SchedulerNavbar;
